export class Populations {
  public static Default = 'Default';
  public static Kids = 'Kids';
  public static Club1901 = 'Club1901';
}
